var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center align-center"},[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_c('div',[_vm._v("Notion integration successful! You can close this window")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }